import React from "react";
import PropTypes from "prop-types";
import Text from "../Text";

const Headline = (props) => {
  const { nivel, reset } = props;
  return (
    <Text
      {...props}
      as={`h${nivel}`}
      textType="headline"
      reset={{ marginBottom: "20px", ...reset }}
    />
  );
};

Headline.defaultProps = {
  nivel: "1",
  text: null,
  styleAs: null,
  reset: null,
  leadMobile: false,
};

Headline.propTypes = {
  nivel: PropTypes.oneOf(["1", "2", "3", "4", "5", "6"]),
  text: PropTypes.string,
  styleAs: PropTypes.oneOf(["1", "2", "3", "4", "5", "6", "7", "8"]),
  reset: PropTypes.instanceOf(Object),
  leadMobile: PropTypes.bool,
};

export default Headline;
